
import {map} from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, URLSearchParams, RequestOptions } from '@angular/http';
import { MenuItem, Logo } from './menu.model';
import { API } from '.././core/app-config';
import { LanguageCompEntity,SystemSetting, CompanyDetailsEntity } from '../admin/user/user.models';

@Injectable()
export class MenuService {
    constructor(private http: Http) { console.log('Info:MenuService constructor.')}

    getMenuItems(companyId: number, loginId: number, languageId: number): Observable<MenuItem[]> {
        return this.http.get(API.USER + '/GetMenu/' + companyId + '/' + loginId + '/' + languageId).pipe(map(res => {console.log(res.json());return <MenuItem[]>res.json()}));
    }
    GetCompanyLogo(CompanyId: number, FileName: string): Observable<Logo> {
        return this.http.get(API.COMPANY + "/GetCompanyLogo/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res =>res.json()));
    }
    logout(url: string): Observable<any> {
        return this.http.get(url).pipe(map(res =>res.json()));
    }

    getAllCompanyLanguage(companyId: number): Observable<LanguageCompEntity[]> {
        return this.http.get(API.COMPANY + "/GetAllCompanyLanguage/" + companyId).pipe(map(resp => resp.json()));
    }
	
	getSystemSettingByIds(companyId: number, settingId: number): Observable<SystemSetting[]> {
        return this.http.get(API.SYSTEMSETTING + "/GetSystemSettingByIds/" + companyId + "/" + settingId).pipe(map(resp => resp.json()));
    }

    QuoteEnabled(companyId: number) {
      return this.http.get(API.COMPANY + "/GetQuoteEnabled/" + companyId).pipe(map(resp => resp.json()));
       
    }
    
    getSystemSettingById(companyId: number, settingId: number[]): Observable<SystemSetting[]> {
        let param:URLSearchParams=new URLSearchParams();
        param.set('SettingIds',settingId.join(','));
       let options: RequestOptions=new RequestOptions({search:param});
      // options.search=param;
        return this.http.get(API.SYSTEMSETTING + "/GetSystemSettingByIds/" + companyId ,options).pipe(map(resp => resp.json()));
    }

    //Added by Anvardeen Batcha 
    getEnableTax(companyId: number) {
        return this.http.get(API.COMPANY + '/GetEnableTax/?CompanyId=' + companyId).pipe(map(resp => resp.json()));
    }
    //Added by Anvardeen Batcha 

 

    //added by senthil kumar g for sprint 59 
    getEnablePolygonRegion(companyId: number) {
        return this.http.get(API.COMPANY + '/GetPolygonRegionEnabled/?CompanyId=' + companyId).pipe(map(resp => resp.json()));
    }


    GetEnablePreferredVendor(companyId: number) {
        return this.http.get(API.COMPANY + '/GetEnablePreferredVendor/?CompanyId=' + companyId).pipe(map(resp => resp.json()));
    }
    GetCompanyDetails(companyId: number):Observable<CompanyDetailsEntity>  {
        return this.http.get(API.COMPANY + '/GetCompanyDetails/' + companyId).pipe(map(resp => resp.json()));
    }
   
}